import RequesterSecurity from "../requesters/security.js";

export default {
  data: function() {
    return {
      platform_subdomain_code: null
    }
  },
  methods: {
    platformSubdomainCode: function (){
      return window.location.href.split("//")[1].split(".")[0];
    },
    checkIfAuthenticated: async function () {
      let check_auth = false;
      if(this.isAuthenticated){
        let response = await RequesterSecurity.authenticated();
        check_auth = (response.data.user_connected_id == this.$store.state.authentication.user_connected_id);
      }
      if(!check_auth) this.$router.push({ name: "logout_path" });
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters["authentication/isLoggedIn"];
    },
    isFullWidth() {
      return this.$store.getters["authentication/fullWidth"];
    }
  }
};
